"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var web3_1 = __importDefault(require("web3"));
function connection(conn) {
    return new web3_1.default(conn).currentProvider;
}
exports.connection = connection;
function injected() {
    // Detect whether the current browser is ethereum-compatible,
    // and throw an error if it is not
    if (window.ethereum === undefined) {
        throw new Error('A web3 provider is not attached to a window.');
    }
    var provider = window.ethereum;
    // disable auto refresh if possible
    if (provider.autoRefreshOnNetworkChange === true) {
        provider.autoRefreshOnNetworkChange = false;
    }
    return provider;
}
exports.injected = injected;
//# sourceMappingURL=providers.js.map